module.exports = __webpack_public_path__ + "img/r1.76edba81.png";